import { z } from 'zod';

// Passthrough function with retyping to avoid the the extra index signature that zod adds from
// version 3.21. This index signature is *technically* correct, since additional elements might be
// present. However additional properties can also be present on any other typescript object without
// being explicitly mentioned in the type. For us the signature just needlessly complicates typing
// down the line without adding additional information. This hack is taken from
// https://github.com/colinhacks/zod/issues/2304#issuecomment-1631438950
export default function objectPassthrough<T extends Parameters<typeof z.strictObject>[0]>(x: T) {
  const result = z.strictObject(x);
  type ReturnType = typeof result;
  return result.loose() as unknown as ReturnType;
}
